(function(scope){
const spec=(p,name)=>String((p.specs||[]).find(s=>s.label.toLowerCase()===name)?.value||'');
function details(p){
 const option=String(p.optionLabel||spec(p,'size')),title=String(p.title||''),features=(p.features||[]).join(' ');
 const count=Number(option.match(/pack of (\d+)/i)?.[1]);
 const titleCount=Number(title.match(/\b(\d+)[ -]pack\b/i)?.[1]);
 const containers=features.match(/includes\s+(\d+)\s+[^.]*?containers\s+and\s+(\d+)\s+lids/i);
 if(containers&&/meal prep/i.test(title)&&count>0&&count<=100){
  const n=Number(containers[1])*count,lids=Number(containers[2])*count;
  return {label:count+' '+(count===1?'pack':'packs')+' · '+n+' containers + '+lids+' lids',quantity:n+' containers + '+lids+' lids',unitPrice:Number(p.price)>0?'$'+(Number(p.price)/n).toFixed(2)+' / container':null,normalized:true};
 }
 if(count&&titleCount&&count!==titleCount)return {label:'Pack quantity needs confirmation on Amazon',quantity:'Unconfirmed',unitPrice:null,normalized:true,conflict:true};
 return {label:option,quantity:count?String(count):spec(p,'number of items'),unitPrice:p.unitPrice||null};
}
function variant(p){
 const d=details(p);if(d.normalized)return d.label;
 const color=spec(p,'color').replace(/^[A-Z],\s*/,'');
 if(/headphone|earbud/i.test(p.title||'')&&color)return color+(spec(p,'model')?' · '+spec(p,'model'):'');
 return p.optionLabel||p.title||p.asin;
}
function labels(options){const names=options.map(variant);return names.map((n,i)=>names.filter(x=>x===n).length>1?n+' · '+options[i].asin:n);}
const api={details,variant,labels};scope.BizedealsProductDetails=api;if(typeof module!=='undefined')module.exports=api;
})(typeof window!=='undefined'?window:globalThis);

